<template>
  <v-card>
    <app-title>My Customer Domains</app-title>
    <v-card-title>
      <v-toolbar-title>My Customers</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-actions
      :search.sync="search"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr
          @click="setDomain(props.item.domain);
      $router.push(`/link/link-actions/${props.item.domain}`);"
        >
          <td class="text-xs-center">{{ props.item.domain }}</td>
          <td class="text-xs-center">{{ props.item.companyName }}</td>
          <td class="text-xs-center">{{ props.item.ubAccountNo }}</td>
          <!-- <td class="text-xs-center">
            <v-btn
              color="success"
              @click="setDomain(props.item.domain);
      $router.push(`/link/link-actions/${props.item.domain}`);"
            >Manage</v-btn>
          </td>-->
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { createHelpers } from "vuex-map-fields";

export default {
  name: "CustomerDomains",
  data() {
    return {
      search: null,
      headers: [
        {
          text: "Domain Name",
          value: "domain",
          align: "center",
          sortable: true,
          class: "",
          width: "30%"
        },
        {
          text: "Customer",
          value: "companyName",
          align: "center",
          sortable: true,
          class: "",
          width: "30%"
        },
        {
          text: "AccountNo",
          value: "ubAccountNo",
          align: "center",
          sortable: false,
          class: "",
          width: "30%"
        }
        // {
        //   text: "Actions",
        //   value: "actions",
        //   align: "center",
        //   sortable: false,
        //   class: "",
        //   width: "30%"
        // }
      ],
      items: []
    };
  },
  mounted() {
    let vm = this;
    vm.getDomainsForCustomer();
  },
  methods: {
    ...mapActions("nampt", ["getCustomerDomains", "setDomain"]),
    ...mapMutations("nampt", ["setDomain"]),
    getDomainsForCustomer() {
      let vm = this;
      vm.getCustomerDomains().then(result => {
        vm.items = result;
      });
    },
    setDomainName(domain) {}
  }
};
</script>

<style lang="scss" scoped>
</style>